// extracted by mini-css-extract-plugin
module.exports = {"container":"_-_-pharmacy-src-input-textEditor-textEditor__container--2qZc0"};